<div class="decline" *ngIf="message">
  <p>{{message}}
  </p>
</div>
